import { cn } from '@/lib/cn';

type SpinnerProps = { size?: number; className?: string; label?: string };

export function Spinner({ size = 14, className, label }: SpinnerProps) {
  return (
    <span
      className={cn(
        'inline-block shrink-0 animate-spin rounded-full border-2 border-current border-r-transparent',
        className,
      )}
      style={{ width: size, height: size }}
      {...(label ? { role: 'status', 'aria-label': label } : { 'aria-hidden': true })}
    />
  );
}
